import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button, CardActions } from '@one-thd/sui-atomic-components';
import DesktopCarousel from './DesktopCarousel';
import MobileCompactList from './MobileCompactList';
import { projectPropType } from '../dataModel';

const { arrayOf, number } = PropTypes;

const ProjectsActions = ({ isCompactView = false }) => (
  isCompactView ? (
    <div className="sui-mt-auto">
      <CardActions>
        <Button fullWidth href="/projects">View All Projects</Button>
      </CardActions>
    </div>
  ) : null
);

ProjectsActions.propTypes = {
  isCompactView: PropTypes.bool
};

const ProjectsContainer = ({
  projects, maxMobileProjectSize, isCompactView, isDashboardSnapshot, fillHeight
}) => {
  return (
    <>
      {/*
        sui-h-full (fillHeight) gives DesktopCarousel's own sui-h-full a definite height to
        resolve against. Growing alone is enough in Chromium and Firefox, but WebKit doesn't
        treat a flexed item's size as definite for a percentage height, so the cards came up
        8px short there whenever the snapshot's height came from its own content.
      */}
      <div
        data-testid="projects-container"
        className={classNames('sui-flex sui-flex-col sui-justify-start sui-grow', { 'sui-h-full': fillHeight })}
      >
        {isCompactView ? (
          <MobileCompactList
            projects={projects}
            maxMobileProjectSize={maxMobileProjectSize}
            isDashboardSnapshot={isDashboardSnapshot}
          />
        ) : (
          <DesktopCarousel
            projects={projects}
            isDashboardSnapshot={isDashboardSnapshot}
            fillHeight={fillHeight}
          />
        )}
        {/*
          Dashboard Snapshot supplies its own counted View All (see ProjectsOverview), which
          would otherwise stack with this uncounted one on mobile.
        */}
        {!isDashboardSnapshot && <ProjectsActions isCompactView={isCompactView} />}
      </div>
    </>
  );
};

ProjectsContainer.propTypes = {
  projects: arrayOf(projectPropType),
  maxMobileProjectSize: number,
  isCompactView: PropTypes.bool,
  isDashboardSnapshot: PropTypes.bool,
  fillHeight: PropTypes.bool
};
ProjectsContainer.defaultProps = {
  projects: [],
  maxMobileProjectSize: 3,
  isCompactView: true,
  isDashboardSnapshot: false,
  fillHeight: false
};
export default ProjectsContainer;
